import React, { useState, useEffect } from "react";

import { Col, Row } from "reactstrap";

import SimpleDonutChart from "./SimpleDonutChart";

export default function TotalizersChart(props) {
  const { title, users, usersTable } = props;
  // todos os usuários
  const [allData, setAllData] = useState([]);
  // usuarios da tabela de listagem
  const [usersTableConfirmed, setUsersTableConfirmed] = useState(0);
  const [usersTablePending, setUsersTablePending] = useState(0);
  var totalUsersTable = usersTableConfirmed + usersTablePending;

  var typeNoRoom = allData.filter((e) => e.status === "noRoom").length;

  const noRoom = [
    {
      x: "noRoom",
      y: typeNoRoom || 0,
    },
    {
      x: "nothing",
      y: (allData.length > 0 ? allData.length : 1) - (typeNoRoom || 0),
    },
  ];

  const confirmed = [
    {
      x: "completed",
      y: usersTableConfirmed || 0,
    },
    {
      x: "nothing",
      y:
        (totalUsersTable > 0 ? totalUsersTable : 1) -
        (usersTableConfirmed || 0),
    },
  ];

  const pending = [
    {
      x: "completed",
      y: usersTablePending || 0,
    },
    {
      x: "nothing",
      y: (totalUsersTable > 0 ? totalUsersTable : 1) - (usersTablePending || 0),
    },
  ];

  const noRoomPercentage =
    typeNoRoom > 0 ? ((typeNoRoom / allData.length) * 100).toFixed(2) : 0;

  const confirmedPercentage =
    usersTableConfirmed > 0
      ? ((usersTableConfirmed / totalUsersTable) * 100).toFixed(2)
      : 0;

  const pendingPercentage =
    usersTablePending > 0
      ? ((usersTablePending / totalUsersTable) * 100).toFixed(2)
      : 0;

  function getValues() {
    const type = title.toUpperCase();

    const data = users.filter((e) =>
      e.group.find((group) => group.name.toUpperCase() === type)
    );
    setAllData(data);

    const roomSize =
      title === "Quadruplo"
        ? 4
        : title === "Triplo"
        ? 3
        : title === "Duplo"
        ? 2
        : 1;

    const usersConfirmed = usersTable.filter(
      (e) => e.roomSize === roomSize && e.status === "completed"
    );

    setUsersTableConfirmed(usersConfirmed.length);

    const usersPending = usersTable.filter(
      (e) => e.roomSize === roomSize && e.status === "pending_accept"
    );
    setUsersTablePending(usersPending.length);
  }

  useEffect(() => {
    if (users?.length > 0) {
      getValues();
    }
  }, [users]);

  return (
    <div
      className="rank-wrapper"
      style={{ height: "auto", marginBottom: title != "Quadruplo" ? 20 : 0 }}
    >
      <Row>
        <span className="title" style={{ textAlign: "center" }}>
          {title}
        </span>
      </Row>

      <div
        style={{
          display: "flex",
          justifyContent: typeNoRoom > 0 ? "space-between" : "space-around",
        }}
      >
        {typeNoRoom && typeNoRoom > 0 ? (
          <div className="dash-match-data">
            <a>Sem quarto</a>

            <div style={{ width: 60 }}>
              <SimpleDonutChart height={60} data={noRoom} />
            </div>

            <span>
              {typeNoRoom} ({noRoomPercentage}%)
            </span>
          </div>
        ) : (
          ""
        )}

        <div className="dash-match-data">
          <a>Confirmados</a>

          <div style={{ width: 60 }}>
            <SimpleDonutChart height={60} data={confirmed} color={"#91cc75"} />
          </div>

          <span>
            {usersTableConfirmed} ({confirmedPercentage}%)
          </span>
        </div>

        <div className="dash-match-data">
          <a>Pendentes</a>

          <div style={{ width: 60 }}>
            <SimpleDonutChart height={60} data={pending} color={"#ee6666"} />
          </div>

          <span>
            {usersTablePending} ({pendingPercentage}%)
          </span>
        </div>
      </div>
    </div>
  );
}
